/* eslint-disable @typescript-eslint/no-unused-expressions */
// @ts-ignore
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useMediaQuery } from 'react-responsive';
import { HiOutlineSwitchVertical } from 'react-icons/hi';
import { FaRegTrashAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Method } from 'axios';

import { handleUserId } from 'store/actions/user-actions';
import api from 'services/api';
import {
  deleteAddressService,
  DeleteUnitProps,
} from 'services/deleteAddressService';
import InputSearch from './InputSearch';
import ModalConfirmDeleteAddress from './ModalConfirmDeleteAddress';
import ModalConfirmDeleteAddressError from './ModalConfirmDeleteAddressError';

import {
  AddressInButton,
  ButtonAddUnit,
  ButtonToggle,
  ButtonToggleContent,
  Container,
  ContentSearch,
  ContentOthersUnits,
  ContentUnit,
  ContentUnits,
  ContentUpper,
  HrCustom,
  TitleAddress,
  TitleOthersUnits,
  UnitSubtitleAddress,
  UnitTitleAddress,
  DeleteButton,
  ContentUnitsWrap,
  ModalConfirmStyled,
} from './styles';

const ChangeOfUnit = (): JSX.Element => {
  const ChangeOfUnitMenuRef = useRef(null);
  const ChangeOfToggleButton = useRef(null);
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [addresses, setAddresses] = useState<any[]>([]);
  const [addressesFiltered, setAddressesFiltered] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [showModalError, setShowModalError] = useState<boolean>(false);
  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
  const [addressToDelete, setAddressToDelete] = useState<DeleteUnitProps>(
    {} as DeleteUnitProps
  );

  const isMobile = useMediaQuery({ maxWidth: 1100 });

  const companyName = localStorage.getItem('@UltragazEmpresarial:customerName');
  const selectedAdress = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const dispatch = useDispatch();

  const handleClickOutside = useCallback(
    (event: any) => {
      if (ChangeOfUnitMenuRef && ChangeOfToggleButton) {
        const { target } = event;
        if (
          // @ts-ignore
          !ChangeOfToggleButton?.current?.contains(target) &&
          // @ts-ignore
          !ChangeOfUnitMenuRef?.current?.contains(target)
        ) {
          setOpenDrawer(false);
        }
      }
    },
    [ChangeOfToggleButton, ChangeOfUnitMenuRef]
  );

  const toggleOpenDrawer = (): void => {
    setOpenDrawer((prevState) => !prevState);
  };

  const requestGetInstallBases = async (userId: string): Promise<void> => {
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');

    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };
    const parameters = {
      method: 'GET' as Method,
      headers: header,
    };
    api
      .get(
        `industrial/customer/v1/users/${userId}/customers?&_limit=1000&_offset=0&address_type=SHIP_TO`,
        parameters
      )
      .then((res) => {
        const response = res.data;
        let addressesData = [] as any[];
        response.map((address: any) => {
          address.customerAddress.map((base: any) => {
            addressesData = [...addressesData, { base, address }];
            return null;
          });
          return null;
        });
        addressesData = addressesData?.sort(function (a, b) {
          if (a.address.name > b.address.name) {
            return 1;
          }
          if (a.address.name < b.address.name) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        setAddresses(addressesData);
        setAddressesFiltered(addressesData);
        setLoading(false);
      })
      .catch((err) => {
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  const requestGetUserInfos = (): void => {
    const login = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    if (login) {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      };
      const parameters = {
        method: 'GET' as Method,
        headers: header,
      };
      api
        .get(
          `industrial/customer/v1/users/?login=${login}&is-active=true`,
          parameters
        )
        .then((res) => {
          const response = res.data[0];
          const { userId, loginCount } = response;
          localStorage.setItem(
            '@UltragazEmpresarial:loginCount',
            loginCount || ''
          );
          dispatch(handleUserId(userId));
          requestGetInstallBases(userId);
        })
        .catch((err) => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err?.response?.status !== 401) {
              toast.error(message);
            }
          } else if (err?.response?.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    }
  };

  useEffect(() => {
    if (document) {
      document.addEventListener('click', handleClickOutside, true);
    }
    if (!addresses.length) requestGetUserInfos();
  }, []);

  const handleSelectAddress = ({
    code,
    siteId,
    customerCode,
    customerId,
    customerName,
    addressLine,
    userCustomerRelationshipId,
    document,
  }: any): void => {
    localStorage.setItem('@UltragazEmpresarial:customerSiteCode', code);
    localStorage.setItem('@UltragazEmpresarial:customerSiteId', siteId);
    localStorage.setItem('@UltragazEmpresarial:customerCode', customerCode);
    localStorage.setItem('@UltragazEmpresarial:customerId', customerId);
    localStorage.setItem('@UltragazEmpresarial:customerName', customerName);
    localStorage.setItem('@UltragazEmpresarial:document', document);
    localStorage.setItem(
      '@UltragazEmpresarial:customerAddressLine',
      addressLine
    );
    localStorage.setItem(
      '@UltragazEmpresarial:userCustomerRelationshipId',
      userCustomerRelationshipId
    );
    localStorage.removeItem('twilio-flex-cf');
    const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const loginEmail = localStorage.getItem('@UltragazEmpresarial:loginEmail');

    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };

    const parameters = {
      method: 'GET' as Method,
      headers: header,
      type: 'EMP',
      _expand: 'CONTACT',
    };
    api.get('industrial/customer/v1/customers/me', parameters).then((res) => {
      const {
        data: { customerAddresses },
      } = res;

      const [address] = customerAddresses.filter(
        (customerAddress: any) =>
          customerAddress.addressType === 'SHIP_TO' &&
          customerAddress.siteId === siteId
      );

      if (!address) {
        return;
      }

      const { contacts } = address;

      if (contacts.length > 0) {
        const contactIdSf = contacts.filter(
          (contact: any) => contact.contact === loginEmail
        )[0]?.contactIdSf;

        if (contactIdSf) {
          localStorage.setItem('@UltragazEmpresarial:contactIdSf', contactIdSf);
        }
      }

      window.location.replace('/portal');
    });
  };

  const changeProfile = useCallback(
    ({
      code,
      siteId,
      customerCode,
      customerId,
      customerName,
      addressLine,
      userCustomerRelationshipId,
      document,
    }: any): void => {
      const token = localStorage.getItem('@UltragazEmpresarial:accessToken');
      const login = localStorage.getItem('@UltragazEmpresarial:loginEmail');

      const header = {
        'Content-Type': 'application/json',
        access_token: token,
      };

      if (addresses.length > 1) {
        setLoading(true);
        const parameters = {
          method: 'POST' as Method,
          headers: header,
        };
        const body = {
          userCustomerRelationshipId,
          username: login,
        };
        api
          .post('industrial/customer/v1/users/change-profile', body, parameters)
          .then((res) => {
            const response = res.data;
            localStorage.setItem(
              '@UltragazEmpresarial:accessToken',
              response.access_token
            );
            handleSelectAddress({
              code,
              siteId,
              customerCode,
              customerId,
              customerName,
              addressLine,
              userCustomerRelationshipId,
              document,
            });
          })
          .catch((err) => {
            setLoading(false);
            const erro = err.response;
            if (erro) {
              const { message } = err.response.data;
              toast.error(message);
            }
          });
      } else {
        handleSelectAddress({
          code,
          siteId,
          customerCode,
          customerId,
          customerName,
          addressLine,
          userCustomerRelationshipId,
          document,
        });
      }

      const parametersGet = {
        method: 'GET' as Method,
        headers: header,
      };

      api
        .get(`industrial/customer/v1/customers/me`, parametersGet)
        .then((res) => {
          const response = res.data;
          localStorage.setItem(
            '@UltragazEmpresarial:document',
            response.document
          );
        });
    },
    [addresses]
  );

  const changeValue = (value: string): void => {
    let addressesFilteredData = [];

    if (value?.length > 0) {
      addressesFilteredData = addresses.filter((addressItem: any) =>
        addressItem?.address?.name?.toLowerCase()?.includes(
          value
            ?.normalize('NFD')
            ?.replace(/[\u0300-\u036f]/g, '')
            ?.toLowerCase()
        )
      );
    } else {
      addressesFilteredData = addresses;
    }

    addressesFilteredData = addressesFilteredData?.sort(function (a, b) {
      if (a.address.name > b.address.name) {
        return 1;
      }
      if (a.address.name < b.address.name) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });

    setAddressesFiltered(addressesFilteredData);
    setSearchValue(value);
  };

  const handleClickDeleteAddress = (address: DeleteUnitProps): void => {
    if (addresses.length === 1) {
      setShowModalError(true);
    } else {
      setShowModalConfirm(true);
    }
    setAddressToDelete(address);

    let buttonClose = null;
    if (isMobile) {
      buttonClose = document.getElementById('react-burger-cross-btn');
      if (buttonClose) {
        buttonClose?.click();
      }
    }
  };

  const confirmDeleteAddress = useCallback(
    async ({ customerCode, document, siteId, code }: DeleteUnitProps) => {
      const userId = localStorage.getItem('@UltragazEmpresarial:userId');

      if (!userId) return;
      const deleteSelectedAddress = selectedAdress === code;

      const response = await deleteAddressService({
        customerCode,
        document,
        siteId,
        code,
        userId,
      });

      if (response.status === 204) setShowModalConfirm(false);

      if (deleteSelectedAddress) {
        const [unitForChange] = addresses.filter(
          (address) => address.base.code !== code
        );

        changeProfile({
          code: unitForChange.base.code,
          siteId: unitForChange.base.siteId,
          customerCode: unitForChange.address.customerCode,
          customerId: unitForChange.address.customerId,
          customerName: unitForChange.address.name,
          addressLine: unitForChange.base.addressLine,
          userCustomerRelationshipId:
            unitForChange.address.userCustomerRelationshipId,
          document: unitForChange.address.document,
        });
      }
    },
    [addresses, selectedAdress, changeProfile]
  );

  const handleConfirmDelete = useCallback(() => {
    confirmDeleteAddress(addressToDelete);
  }, [addressToDelete, confirmDeleteAddress]);

  return (
    <Container>
      <ButtonToggle onClick={toggleOpenDrawer} ref={ChangeOfToggleButton}>
        <ButtonToggleContent>
          {loading ? (
            <span>Carregando...</span>
          ) : (
            <AddressInButton>
              <TitleAddress>{companyName}</TitleAddress>
            </AddressInButton>
          )}
          <HiOutlineSwitchVertical size={16} />
        </ButtonToggleContent>
      </ButtonToggle>

      <ContentUpper show={openDrawer} ref={ChangeOfUnitMenuRef}>
        <ContentOthersUnits>
          <HrCustom />
          <TitleOthersUnits>Empresas cadastradas:</TitleOthersUnits>
          <ContentSearch>
            <InputSearch
              searchValue={searchValue}
              setSearchValue={(value: string) => {
                changeValue(value);
              }}
            />
          </ContentSearch>
          <ContentUnits>
            {addressesFiltered?.map(({ base, address }) => {
              return (
                <>
                  <ContentUnit
                    key={base.code}
                    selected={selectedAdress === base.code}
                    onClick={() => {
                      changeProfile({
                        code: base.code,
                        siteId: base.siteId,
                        customerCode: address.customerCode,
                        customerId: address.customerId,
                        customerName: address.name,
                        addressLine: base.addressLine,
                        userCustomerRelationshipId:
                          address.userCustomerRelationshipId,
                        document: address.document,
                      });
                    }}
                  >
                    <ContentUnitsWrap>
                      <UnitTitleAddress>{address.name || ''}</UnitTitleAddress>
                      <DeleteButton
                        isMobile={isMobile}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleClickDeleteAddress({
                            customerCode: address.customerCode,
                            document: address.document,
                            siteId: base.siteId,
                            code: base.code,
                          });
                          setOpenDrawer(false);
                        }}
                      >
                        <FaRegTrashAlt
                          color={
                            selectedAdress === base.code ? '#fff' : '##818181'
                          }
                          size={16}
                        />
                      </DeleteButton>
                    </ContentUnitsWrap>
                    <UnitSubtitleAddress>
                      {`${base.addressLine}, ${base.addressNumber}${
                        base.complement ? ' - ' : ''
                      }${(base.complement || '')
                        .toLowerCase()
                        .replace(/(?:^|\s)\S/g, function (a: string) {
                          return a.toUpperCase();
                        })} - ${base.city} - ${base.stateCode}`}
                    </UnitSubtitleAddress>
                  </ContentUnit>
                </>
              );
            })}
          </ContentUnits>
        </ContentOthersUnits>
        <ButtonAddUnit to="/nova-empresa" onClick={() => setOpenDrawer(false)}>
          <AiOutlinePlus />
          <span>Adicionar empresa</span>
        </ButtonAddUnit>
      </ContentUpper>
      <ModalConfirmStyled show={showModalConfirm} animation={false} centered>
        <ModalConfirmDeleteAddress
          loading={false}
          onClickFail={() => {
            setShowModalConfirm(false);
          }}
          onClickSuccess={handleConfirmDelete}
        />
      </ModalConfirmStyled>
      <ModalConfirmStyled show={showModalError} animation={false} centered>
        <ModalConfirmDeleteAddressError
          onClickFail={() => {
            setShowModalError(false);
          }}
        />
      </ModalConfirmStyled>
    </Container>
  );
};

export default ChangeOfUnit;
